import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './SRLStudentResponses.module.css';

const conditionallyRenderPrompt = (prompt) => {
  if (prompt) {
    return (
      <div className={styles.prompt}> {prompt} </div>
    );
  }
  return null;
};

const renderStudentResponses = (studentResponses, responseLimit, lineLimit) => {
  let responses = studentResponses || [];
  if (responseLimit) {
    responses = responses.slice(0, responseLimit);
  }

  const studentResponsesClasses = clsx(styles.studentResponses, {
    [styles.twoLines]: lineLimit === 2,
    [styles.threeLines]: lineLimit === 3,
    [styles.fourLines]: lineLimit === 4,
  });

  return (
    <div> {responses.map((response, index) => (
      <div key={index} className={styles.studentResponseContainer}>
        <div className={studentResponsesClasses}>
          {response.student_response}
        </div>
        <div className={styles.studentSignature}>
          - student response
        </div>
      </div>
    ))}
    </div>
  );
};

function SRLStudentResponses({ prompt, studentResponses, responseLimit, lineLimit }) {
  return (
    <div className={styles.container}>
      {conditionallyRenderPrompt(prompt)}
      {renderStudentResponses(studentResponses, responseLimit, lineLimit)}
    </div>
  );
}

SRLStudentResponses.propTypes = {
  prompt: PropTypes.string,
  studentResponses: PropTypes.array.isRequired, // Add string to type of array
  responseLimit: PropTypes.number,
  lineLimit: PropTypes.number,
};

export default SRLStudentResponses;

